import { useEffect, type ReactNode } from 'react';

interface PostHogProviderProps {
  children: ReactNode;
}

/**
 * Client-only PostHog provider that initializes PostHog after hydration
 * This prevents SSR issues with the posthog-js library
 */
export function PostHogProvider({ children }: PostHogProviderProps) {
  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;

    // Dynamically import and initialize PostHog
    import('posthog-js').then((posthog) => {
      const apiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
      const apiHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

      if (apiKey && apiHost) {
        posthog.default.init(apiKey, {
          api_host: apiHost,
          person_profiles: 'identified_only',
          capture_pageview: true,
          capture_pageleave: true,
          debug: import.meta.env.MODE === 'development',
        });
      }
    });
  }, []);

  return <>{children}</>;
}
